import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import * as queryString from 'query-string'

import {
	CirclesAnswers,
	ImageAnswers,
	MediaAnswers,
	TextAnswers,
} from '../../components/questions'
import { QuestionInfo } from '../../components/questions/common'
import { types } from '../../redux/initialStates/questions/questionType'
import {
	getQuestions,
	getQuestionsCount,
} from '../../redux/slices/questionsSlice'
import { getIsLegalFlow, getUserId } from '../../redux/slices/userSlice'
import { ampEventWithEventProperty } from '../../utils/amplitude'

import './styles.scss'
import { paramsToQuery } from '../../utils/historyDecorators'
import { getInitialPrice, getUpsellPrice } from '../../redux/slices/configSlice'

const QuestionScreen = props => {
	const { id } = useParams()
	const history = useHistory()
	const params = queryString.parse(location.search)
	const isLegalFlow = useSelector(getIsLegalFlow)
	const user_id = useSelector(getUserId)
	const upsell_test = params?.upsell_test || useSelector(getUpsellPrice)
	const initial_price = params?.initial_price || useSelector(getInitialPrice)

	const questions = useSelector(getQuestions)
	const questionsCount = useSelector(getQuestionsCount)

	const [isActive, setIsActive] = useState(false)

	const questionById = questions[id - 1]

	if (!questionById) {
		return null
	}

	const nextQuestion = () => {
		ampEventWithEventProperty('Question_answered', {
			question: `${parseInt(id) + 1}`,
		})

		const isLastQuestion = +id === questionsCount

		if (!isLastQuestion) {
			setIsActive(false)

			setTimeout(() => {
				history.push({
					pathname: `/question/${+id + 1}`,
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
					state: { prediction: props.location.state?.prediction },
				})
				setIsActive(true)
			}, 700)
			return
		}

		setIsActive(false)
		setTimeout(() => {
			history.push({
				pathname: '/processing',
				search: isLegalFlow
					? paramsToQuery({ user_id, external_id: user_id })
					: paramsToQuery({
							user_id,
							external_id: user_id,
							upsell_test,
							initial_price,
					  }),
			})
		}, 350)
	}

	const questionsController = () => {
		switch (questionById.componentType) {
			case types.TEXT_ANSWERS: {
				return (
					<TextAnswers question={questionById} nextQuestion={nextQuestion} />
				)
			}
			case types.WITHOUT_EMOJI_TEXT_ANSWERS: {
				return (
					<TextAnswers question={questionById} nextQuestion={nextQuestion} />
				)
			}
			case types.CIRCLES_ANSWERS: {
				return (
					<CirclesAnswers question={questionById} nextQuestion={nextQuestion} />
				)
			}
			case types.MEDIA_ANSWERS: {
				return (
					<MediaAnswers question={questionById} nextQuestion={nextQuestion} />
				)
			}
			case types.IMAGE_ANSWERS: {
				return (
					<ImageAnswers question={questionById} nextQuestion={nextQuestion} />
				)
			}
			default: {
				return <p>Component now found</p>
			}
		}
	}

	useEffect(() => {
		setTimeout(() => {
			setIsActive(true)
		}, 700)
	}, [])

	return (
		<div className={`question ${isActive ? 'question--active' : ''}`}>
			<QuestionInfo
				id={id}
				question={questionById.question}
				questionsCount={questionsCount}
			/>
			<div className="answers">{questionsController()}</div>
		</div>
	)
}

export { QuestionScreen }
